<template>
  <div>
    <ds-row>
      <ds-col>
        <ds-button theme="primary" @click="openRegisterRollover">
          Nova Alocação e Retenção
        </ds-button>
      </ds-col>
    </ds-row>

    <ds-row>
      <ds-col>
        <ds-page>
          <ds-col size="3">
            <ds-date-period-filter
              period-type="this-month"
              :value="localPeriod"
              :period-types="periodTypes"
              @input="onPeriodChange" />
          </ds-col>
          <ds-data-grid
            ref="dsDataGrid"
            show-actions
            :columns="columns"
            :pagination="pagination"
            :batch-remove-action="batchRemoveAction"
            :fetch-action="fetchAction"
            @fetch-success="onFetchSuccess">
            <ds-data-grid-tr
              v-for="serviceTaker in serviceTakers"
              :key="serviceTaker.id"
              :item="serviceTaker"
              :confirm-title="confirmTitle"
              :confirm-question="confirmQuestion"
              :edit-action="editAction"
              :remove-action="removeAction">
              <ds-td>{{ serviceTaker.serviceTakerName }}</ds-td>
              <ds-td>{{ serviceTaker.registration }}</ds-td>
              <ds-td>{{ serviceTaker.allocated }}</ds-td>
              <ds-td>{{ serviceTaker.invoiceNumber }}</ds-td>
              <ds-td>R$ {{ serviceTaker.inssRetentionAmount | caCurrency }}</ds-td>
            </ds-data-grid-tr>
          </ds-data-grid>
        </ds-page>
      </ds-col>
    </ds-row>
  </div>
</template>

<script>
import { SERVICE_TAKER_ALLOCATION_GRID_COLUMNS, CONFIRM_TITLE, CONFIRM_QUESTION } from './constants';
import { deleteBatchServiceTakerAllocations, periodToCompetence } from './serviceTakerAllocationService';
import ServiceTakerAllocationRollover from './modal/ServiceTakerAllocationRegisterRollover';

export default {
  name: 'ServiceTakerAllocationListPage',
  props: {
    fetchAction: Function,
    serviceTakers: {
      type: Array,
      required: true,
    },
    pagination: {
      type: Object,
      required: true,
    },
    period: {
      type: Object,
    },
  },
  data() {
    return {
      columns: SERVICE_TAKER_ALLOCATION_GRID_COLUMNS,
      periodTypes: ['this-month'],
      confirmTitle: CONFIRM_TITLE,
      confirmQuestion: CONFIRM_QUESTION,
      localPeriod: this.period,
    };
  },
  methods: {
    onFetchSuccess(data) {
      this.$emit('fetch-success', data);
    },
    onPeriodChange(period) {
      this.localPeriod = period;
      this.$emit('period-change', period);
      if (this.$refs?.dsDataGrid) {
        this.$refs.dsDataGrid.refreshTable(true);
      }
      this.$nextTick();
    },
    editAction({ id }) {
      ServiceTakerAllocationRollover.open({
        allocationId: id,
        competence: periodToCompetence(this.period.startDate),
      }, {
        on: {
          'refresh-list': this.onPeriodChange,
        },
      });
    },
    removeAction({ id }) {
      return this.batchRemoveAction([{ id }]);
    },
    batchRemoveAction(data) {
      return deleteBatchServiceTakerAllocations(this.period, data);
    },
    openRegisterRollover() {
      ServiceTakerAllocationRollover.open({}, {
        on: {
          'refresh-list': this.onPeriodChange,
        },
      });
    },
  },
};
</script>
